import React from 'react';
import { Box, Typography } from '@mui/material';

function Page2SubPageB1b() {
  return (
    <Box p={4}>
      <Typography variant="h4">State</Typography>
    </Box>
  );
}

export default Page2SubPageB1b;
